import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import SubmitProposlWidget from '../../widgets/submitProposal/SubmitProposlWidget'
import { getProjectSubmitForm } from '../../redux/actions/submitProposal'
import { startLoading, doneLoading } from '../../utils/loading'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import { ERR_MSG_404_PROJECT_ID } from '../../constants/msgText'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'

export default function SubmitProposalView() {
  const [isLoading, setIsLoading] = useState(false)
  const [schemas, setSchemas] = useState()
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    if (projectId) {
      handleGetSchema(projectId)
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_PROJECT_ID,
      })
    }
  }, [])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getProjectSubmitForm(proposalId)

      setSchemas(_schema)
    } catch (e) {
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schemas || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal>
        <ContentHeader header={schemas.header} subHeader={schemas.subHeader} />

        <SubmitProposlWidget
          schema={schemas.forms.projectSubmit}
          schemaPdpa={schemas.forms.pdpa}
          hideSpecialOrganization={schemas.formTemplate == 0}
          alwaysEnableFinalSubmitButton={schemas.formTemplate == 0}
          isAIEvaliation={schemas?.forms?.isEvaluation}
        />
      </SidebarProposal>
    </>
  )
}
